// Navigation - Add Class = Active

jQuery(document).ready(function ($) {

    // Add Class to Navigation
    $('.navigation-mobile').click(function () {
        $(this).toggleClass('active').siblings().removeClass('active');
    });

    $('.content__menu').on("click", function () {
        $(this).toggleClass("menu-open");
    });

    // Navigation Sub-Menu Arrow
        $('.menu-item-has-children').each(function () {
             $('<i class="arrow-down"></i>').prependTo(this).on("click", function (e) {
                    e.stopPropagation();
                    $(this).toggleClass("arrow-down__open");
                    $(this).siblings('.sub-menu').slideToggle();
                });
    });

    $('a[href^="#"]').click(function (event) {
        event.preventDefault();
        var target = $(this.hash);
        $('html, body').animate({
            scrollTop: target.offset().top - 100
        }, 500);
    });

    // Fade video play button 
    // $('.block-site-hero__video').click(function () {
    //     var videoEl = $(this).find('video').get(0);

    //     if (videoEl.paused) {
    //         videoEl.play();
    //         $(this).find('.block-site-hero__video--play-button').fadeOut();
    //     } else {
    //         videoEl.pause();
    //         $(this).find('.block-site-hero__video--play-button').fadeIn();
    //     }
    // });

    // $('.block-video__video').click(function () {
    //     var videoEl = $(this).find('video').get(0);

    //     if (videoEl.paused) {
    //         videoEl.play();
    //         $(this).find('.block-video__video--play-button').fadeOut();
    //     } else {
    //         videoEl.pause();
    //         $(this).find('.block-video__video--play-button').fadeIn();
    //     }
    // });

    // Create and append the scroll-to-top button
    var scrollTopBtn = $('<a>', {
        id: 'scroll-to-top',
        href: '#',
        title: 'Seitenanfang'
    }).appendTo('body');

    // Add the arrow and text to the button
    $('<span>', { class: 'arrow' }).text('↑').appendTo(scrollTopBtn);
    $('<br>').appendTo(scrollTopBtn);
    $('<span>').text('Seitenanfang').appendTo(scrollTopBtn);

    function updateButtonPosition() {
        if ($(window).width() > 1920) {
            var rightPosition = ($(window).width() - 1920) / 2 + 24;
            scrollTopBtn.css('right', rightPosition + 'px');
        } else {
            scrollTopBtn.css('right', '24px');
        }
    }

    function updateButtonColor() {
        var scrollTopBtnTop = scrollTopBtn.offset().top;
        var footerTop = $('.page-footer').offset().top;

        if (scrollTopBtnTop + scrollTopBtn.outerHeight(true) >= footerTop) {
            scrollTopBtn.addClass('white-color');
        } else {
            scrollTopBtn.removeClass('white-color');
        }
    }

    $(window).on('scroll', function () {
        if ($(window).scrollTop() > 240) {
            scrollTopBtn.fadeIn();
        } else {
            scrollTopBtn.fadeOut();
        }

        updateButtonColor();
    });

    $(window).on('resize', updateButtonPosition);

    scrollTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    });

    // Initial check for button position and color
    updateButtonPosition();
    updateButtonColor();
});


// Hide video controls for all players
// var vids = jQuery('video');
// jQuery.each(vids, function () {
//     this.controls = false;
// });